import { Icon, type IconProps } from '@repo/ui/Icon';
import type { CalloutVariant } from './Callout';
import s from './CalloutIcon.module.css';

export type CalloutIconProps = {
  variant: CalloutVariant;
};

const getPropsFromVariantName = (variant: CalloutVariant): IconProps => {
  switch (variant) {
    case 'info':
    default:
      return {
        className: s.info,
        name: 'info',
        size: 'sm',
      };
  }
};

export const CalloutIcon = (props: CalloutIconProps) => {
  const { variant } = props;
  const iconProps = getPropsFromVariantName(variant);
  return <Icon {...iconProps} />;
};
